import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { font } from '@styles/fonts';
import { isWeb } from '@helpers';
import { ColorFunction } from '@styles/colors/types';
import TimeDisplay from '@components/common/TimeDisplay';

export default ({
  seconds,
  C,
  color,
  name,
  left,
  topPopupWidth,
  zIndex,
}: {
  seconds: number;
  left: number;
  zIndex: number;
  topPopupWidth: number;
  C: ColorFunction;
  color: string;
  name: string;
}) => {
  return (
    <View style={{ alignItems: 'center', justifyContent: 'center', position: 'absolute', top: isWeb ? 0 : -2, width: topPopupWidth, left, zIndex }}>
      <View style={{ alignItems: 'center', width: '100%' }}>
        <Text numberOfLines={1} style={[font['Subhead 2'], { color: C(color) }]}>
          {i18n.t(name)}
        </Text>
        <View
          style={{
            backgroundColor: C('Gray/Light/6'),
            paddingHorizontal: 6,
            paddingVertical: 4,
            flexDirection: 'row',
            borderRadius: 2,
            marginTop: 1,
            width: '100%',
            justifyContent: 'center',
          }}
        >
          <TimeDisplay withHMSFormat value={seconds ?? 0} C={C} fontForDigit="Time 2" fontForSecondDigit="Time 4" color={color} />
        </View>
        <View style={{ width: 1, height: 6, backgroundColor: C(color) }} />
      </View>
    </View>
  );
};
